import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api, candidateApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for post massmail
export const postMassmail = createAsyncThunk(
  "add/massmail",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/req/job/mass-mail/", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all recuiter and candidates
export const getAllRecruiterCandidate = createAsyncThunk(
  "get/recruiterCandidate",
  async (jobDetails, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(
        `/candidate/resume/resume-profile/?${jobDetails}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all recuiter and candidates next and previous
export const getAllRecruiterCandidateNextPrevious = createAsyncThunk(
  "get/recruiterCandidate/nextPrevious",
  async (url, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all recuiter and candidates
export const getAllMassmailHistory = createAsyncThunk(
  "get/all/massmail/history",
  async (query, { rejectWithValue }) => {
    try {
      const response = await api.get(`/req/job/mass-mail/history/?${query}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all recuiter and candidates
export const getAllMassmailHistoryOnJob = createAsyncThunk(
  "get/all/massmail/history/jobid",
  async (jobID, { rejectWithValue }) => {
    try {
      const response = await api.get(`/req/job/mass-mail/history/${jobID}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const massmailSlice = createSlice({
  name: "massmail",
  initialState: {
    data: null,
    historyData: null,
    historyOneData: null,
    status: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(postMassmail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postMassmail.fulfilled, (state, action) => {
        state.status = "post_massmail_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(postMassmail.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getAllRecruiterCandidate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllRecruiterCandidate.fulfilled, (state, action) => {
        state.status = "get_all_recruiter_candidate_succeeded";
        state.data = action.payload;
      })
      .addCase(getAllRecruiterCandidate.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getAllRecruiterCandidateNextPrevious.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        getAllRecruiterCandidateNextPrevious.fulfilled,
        (state, action) => {
          state.status = "get_list_next_prevoios_succeeded";
          state.data = action.payload;
        }
      )
      .addCase(
        getAllRecruiterCandidateNextPrevious.rejected,
        (state, action) => {
          state.status = "failed";
          toast.error(action.payload?.message);
        }
      )
      .addCase(getAllMassmailHistory.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllMassmailHistory.fulfilled, (state, action) => {
        state.status = "get_all_massmail_history_succeeded";
        state.historyData = action.payload;
      })
      .addCase(getAllMassmailHistory.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getAllMassmailHistoryOnJob.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllMassmailHistoryOnJob.fulfilled, (state, action) => {
        state.status = "get_one_massmail_history_succeeded";
        state.historyOneData = action.payload;
      })
      .addCase(getAllMassmailHistoryOnJob.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export default massmailSlice.reducer;
